import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import DeviationSelector from '../../DeviationSelector';
import withGallectionDeviations from '../../../_hocs/withCurrentGallectionDeviations';
import withCurrentGallection from '../../../_hocs/withCurrentGallection';
import withCurrentSubfolder from '../../../_hocs/withCurrentSubfolder';
import LoadingIndicator from '../../../../LoadingIndicator';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import SearchInput from '../../../_partials/SearchInput';
import withSearch from '../../../_hocs/withSearch';
import NoSearchResults from '../../../_partials/NoSearchResults';
import withFileUpload from '../../../_hocs/withFileUpload';
import Flex from '@wix/da-ds/pkg/Flex';
import SelectableSubfolderSlider from '../../../_partials/SelectableSubfolderSlider';
import { GallectionType } from '../../../../types/gallection';
const enhance = compose(withGallectionDeviations, withCurrentGallection, withCurrentSubfolder, withSearch, withFileUpload, withTranslation());
export class GallectionDeviationSelector extends React.Component {
    render() {
        const { currentSubfolderId, disableSearch } = this.props;
        return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
            headerExtrasRightZone: disableSearch ? undefined : /*#__PURE__*/ React.createElement(SearchInput, null),
            headerExtrasBottomZone: /*#__PURE__*/ React.createElement(React.Fragment, null, !currentSubfolderId && /*#__PURE__*/ React.createElement(SelectableSubfolderSlider, null), /*#__PURE__*/ React.createElement(SelectedItemsPanel, null)),
            scrollableContent: this.renderContent(),
            onScrolledToBottom: this.fetchMoreGallectionDeviationsIfNeeded,
            onNotScrollable: this.fetchMoreGallectionDeviationsIfNeeded
        });
    }
    renderContent() {
        const { isInitialized, isFetching, fileUploads, hasMore, deviations } = this.props;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isInitialized && (!deviations.length && !fileUploads.length && !isFetching && !hasMore ? this.renderEmpty() : /*#__PURE__*/ React.createElement(DeviationSelector, {
            deviations: deviations
        })), (!isInitialized || isFetching) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: "daSymbol",
            coverMode: !hasMore && !isFetching
        }));
    }
    renderEmpty() {
        const { searchQuery } = this.props;
        if (searchQuery) {
            return /*#__PURE__*/ React.createElement(NoSearchResults, null);
        }
        return /*#__PURE__*/ React.createElement(Flex, {
            fullWidth: true,
            fullHeight: true,
            direction: "column",
            justifyContent: "center",
            alignItems: "center"
        }, this.getEmptyText());
    }
    getEmptyText() {
        var _currentGallection;
        const { t, currentGallection } = this.props;
        switch((_currentGallection = currentGallection) === null || _currentGallection === void 0 ? void 0 : _currentGallection.type){
            case GallectionType.STASH:
                return t('mediapopup.empty.stash');
            case GallectionType.GALLERY:
                return t('mediapopup.empty.gallery');
            case GallectionType.COLLECTION:
                return t('mediapopup.empty.collection');
            default:
        }
    }
    constructor(...args){
        super(...args);
        _define_property(this, "fetchMoreGallectionDeviationsIfNeeded", ()=>{
            const { hasMore, isFetching, fetchMoreGallectionDeviations } = this.props;
            if (!hasMore || isFetching) {
                return;
            }
            fetchMoreGallectionDeviations();
        });
    }
}
export default enhance(GallectionDeviationSelector);
